import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faCircleMinus } from "@fortawesome/free-solid-svg-icons";
import "./trocRequest.css";
import { formatedDate } from "../../services/hooks/formatedDate";
import { capitalizeFirstCharForRequestState } from "../../services/hooks/stringDataType";
import { ITrocPropositionResident } from "../../services/interfaces/ITrocResident2";
import { ITrocsProposalsTableProps } from "../../services/interfaces/ITrocsProposalsTable";
import AcceptProposal from "../modales/res/acceptProposal/AcceptProposal";
import DeclineProposal from "../modales/res/DeclineProposal";
import BtnIconeProposalTrash from "../buttons/btnRes/BtnIconeProposalTrash";
import ShareExpRes from "../modales/res/ShareExpRes";
import TrocDoneRes from "../modales/res/TrocDoneModal";
import DiscussModal from "../modales/DiscussModal";
import { TravPublicModal } from "../modales/profilModal/TravPublicModal";
import IndicateServiceNeedName from "../indicateSerNeedName/IndicateSerNeedName";

interface ITableBodyNotFilteredAndFiltredProps {
  trocsPropositionsList: ITrocPropositionResident[];
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
  setServiceNeedName: React.Dispatch<React.SetStateAction<string | null>>;
  setisIndicateServiceNeedName: React.Dispatch<React.SetStateAction<boolean>>;
}

// main component
function TrocsPropositionsTable(props: ITrocsProposalsTableProps) {
  //destructuring
  const { selectedOption, trocsPropositionsList, setTrigUseEffect } = props;

  /* filter trocsPropositionsList */
  const trocsPropositionsListFiltered = trocsPropositionsList.filter((proposal) => proposal.proposition_state === selectedOption);

  const [serviceNeedName, setServiceNeedName] = useState<string | null>("");
  const [isIndicateServiceNeedName, setisIndicateServiceNeedName] = useState<boolean>(false);

  return (
    <div id="div-table" className="relative max-h-[calc(100vh-8rem)] overflow-y-auto shadow-md sm:rounded-lg">
      <table id="table-request-troc" className="w-full table-auto text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead id="thead-request-troc" className="bg-orangeCustom sticky top-0 text-white dark:bg-gray-700 dark:text-gray-400 ">
          <tr className="rounded-bl-lg">
            <th id="th-statut" scope="col" className="text-center">
              STATUT
            </th>
            <th scope="col" className="text-center">
              VOYAGEURS
            </th>
            <th id="th-date" scope="col" className="text-center">
              DATE
            </th>
            <th id="th-place" scope="col" className="text-center">
              LIEU
            </th>
            <th id="th-last-col" scope="col" className="actions">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        {
          trocsPropositionsListFiltered.length === 0 ? (<ProposalsTableBodyNotFiltered trocsPropositionsList={trocsPropositionsList} setTrigUseEffect={setTrigUseEffect} setServiceNeedName={setServiceNeedName} setisIndicateServiceNeedName={setisIndicateServiceNeedName} />) : (<ProposalsTableBodyFiltered trocsPropositionsList={trocsPropositionsListFiltered} setTrigUseEffect={setTrigUseEffect} setServiceNeedName={setServiceNeedName} setisIndicateServiceNeedName={setisIndicateServiceNeedName} />)
        }
      </table>

      {/* Fenêtre modale */}
      {isIndicateServiceNeedName && <IndicateServiceNeedName name={serviceNeedName} setisIndicateServiceNeedName={setisIndicateServiceNeedName} />}
    </div>
  );
}
export default TrocsPropositionsTable;

//TableBodyFiltered component
function ProposalsTableBodyFiltered(props: ITableBodyNotFilteredAndFiltredProps) {
  //destructuring
  const { trocsPropositionsList, setTrigUseEffect, setServiceNeedName, setisIndicateServiceNeedName } = props;

  const [expandedRowIndex, setExpandedRowIndex] = useState<number | null>(null);

  const [selectedRow, setSelectedRow] = useState<number>();

  const [iconStates, setIconStates] = useState<boolean[]>(new Array(trocsPropositionsList.length).fill(true));

  function handleExpandedRow(index: number) {
    // Si la ligne est déjà étendue, la rétracter
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null); // Rétracte la ligne
    } else {
      setExpandedRowIndex(index); // Étend la nouvelle ligne
    }
  }

  function handleSwitchIcon(rowNumber: number) {
    setSelectedRow(rowNumber);

    // Inverse l'état de l'icône pour la ligne cliquée
    setIconStates(prev => {
      const newState = [...prev];

      //asign false to icon selected to display a minus
      newState[rowNumber] = false;

      //compare iconStates initiale vs newsState
      if (prev[rowNumber] === newState[rowNumber]) {//si cliqué au meme endroit

        //asign true to icon selected to display a Plus
        newState[rowNumber] = true;

        return newState;

      }
      else {//si pas cliqué au meme endroit

        //reset IconStates to true
        const newsState2 = newState.map(() => true);

        newsState2[rowNumber] = false;

        return newsState2;
      }
    });
  }

  const handleClickToIndicateServNeedName = (serviceOrNeeedName: string | null) => {
    setServiceNeedName(serviceOrNeeedName);
    setisIndicateServiceNeedName(true);
  };

  return (
    <tbody id="tbody-troc-request" className="text-black sm:text-sm lg:text-base">
      {trocsPropositionsList
        .map((proposal, index) => (
          <React.Fragment key={index}>

            {/* part body */}
            <tr className={`${selectedRow === index && expandedRowIndex === index ? "bg-gray-200" : null} hover:bg-gradient-to-b hover:from-gray-200 hover:to-gray-100 py-1 border-b dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-600 cursor-pointer`} onClick={() => { handleExpandedRow(index), handleSwitchIcon(index) }}>
              <td scope="row" className="font-semibold text-gray-900 whitespace-nowrap dark:text-white text-center">
                {capitalizeFirstCharForRequestState(proposal.proposition_state)}
              </td>
              <td className="text-center">
                <TravPublicModal pseudo={proposal.trav_pseudo} />
              </td>
              <td className="td-date-pg-req-troc text-center">
                {formatedDate(proposal.start_date.toString())} au {formatedDate(proposal.end_date.toString())}
              </td>
              <td className="text-center">
                {proposal.res_region}
              </td>
              <td id={`td-icon-plus${index}`} className="td-icon-plus text-center">
                <FontAwesomeIcon className="py-1 text-greenCustom h-8" icon={iconStates[index] ? faCirclePlus : faCircleMinus} />
              </td>
            </tr>

            {/* part expanded row */}
            {expandedRowIndex === index && (
              <>
                <tr id={`tr-expanded-row${index}`} className="bg-white">
                  <td colSpan={5}>
                    <div id="div-expanded-row" className="flex flex-col justify-around items-center gap-2">

                      {/* part title */}
                      {proposal.title.charAt(0).toUpperCase() + proposal.title.slice(1).toLocaleLowerCase()}

                      {/* date */}
                      <div id="date-expand-row" className="flex justify-center">
                        <p className="date-expand-row font-medium">Du {formatedDate(proposal.start_date.toString())} au {formatedDate(proposal.end_date.toString())}</p>
                      </div>

                      {/* separator row */}
                      <span className="border-t border-gray-300 block w-full" />

                      {/* services and needs */}
                      <div className="div-ser-needs flex flex-col justify-around gap-3 w-full">

                        {/* services */}
                        <div id="services" className="flex-1 flex flex-col justify-center gap-2">

                          <label className="block text-center font-medium text-sm sm:text-base lg:text-lg">Ses Services</label>

                          <div id="services-list" className="flex flex-wrap justify-center gap-6">
                            {proposal.services
                              .filter((service) => service != null)
                              .map((service, index) => (
                                <img
                                  key={index}
                                  className="h-20 w-20 cursor-pointer"
                                  src={`${"/servicesDuNomade-besoinsDuRésident/" + service + ".png"}`}
                                  alt={`image ${service}`}
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ))
                            }
                          </div>

                        </div>

                        {/* needs */}
                        <div id="needs" className="flex-1 flex flex-col justify-center gap-2">

                          <label className="block text-center font-medium text-sm sm:text-base lg:text-lg">Ses Besoins</label>

                          <div id="needs-list" className="flex flex-wrap justify-center gap-6">
                            {proposal.needs
                              .filter((service) => service != null)
                              .map((service, index) => (
                                <img
                                  key={index}
                                  className="h-20 w-20 cursor-pointer"
                                  src={`${"/besoinsDuNomade-servicesDuRésident/" + service + ".png"}`}
                                  alt={`image ${service}`}
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ))
                            }
                          </div>

                        </div>

                      </div>

                    </div>

                  </td>
                </tr>

                <tr id="tr-expanded-row-descrip" className="mt-1 border-none text-black ">
                  <td colSpan={5} className="p-0">

                    {/*separator row  */}
                    <span className="border-t border-gray-300 block mt-1" />

                    {/* Decription du troc */}
                    <div className="my-2 flex flex-col items-center justify-around gap-1">
                      <h2 className="font-medium text-sm sm:text-base lg:text-lg">Description</h2>

                      <div className="border-4 rounded-md overflow-y-auto max-h-16 max-w-[900px] px-2">
                        <p className="break-words text-sm">{proposal.description}</p>
                      </div>

                    </div>

                    {/* actions different */}
                    <div className="actions flex justify-between items-center gap-2 text-sm sm:text-base lg:text-lg">
                      {proposal.proposition_state === "EN_ATTENTE" ?
                        <>
                          <DeclineProposal travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                          <AcceptProposal travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                        </> :
                        null
                      }
                      {proposal.proposition_state === "REFUSEE" ?
                        <BtnIconeProposalTrash resTrocId={proposal.against_r_troc_pair_id} travTrocId={proposal.trav_Troc_Id} setTrigUseEffect={setTrigUseEffect} /> :
                        null
                      }
                      {proposal.proposition_state === "EFFECTUEE" && proposal.is_commented === false ?
                        <ShareExpRes travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                        :
                        proposal.proposition_state === "EFFECTUEE" && proposal.is_commented === true ?
                          <BtnIconeProposalTrash travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                          :
                          null
                      }
                      {proposal.proposition_state === "ACCEPTEE" ?
                        <div className="w-full flex justify-between">
                          <TrocDoneRes resTrocId={proposal.against_r_troc_pair_id} travTrocId={proposal.trav_Troc_Id} setTrigUseEffect={setTrigUseEffect} />
                          <DiscussModal res_troc_id={proposal.against_r_troc_pair_id} trav_troc_id={proposal.trav_Troc_Id} />
                        </div> :
                        null
                      }
                    </div>

                    {/*separator row  */}
                    <span className="border-t border-gray-300 block mt-3" />

                  </td>
                </tr>
              </>
            )}
          </React.Fragment>
        ))
      }
    </tbody>
  )
}

//TableBodyNotFiltered component
function ProposalsTableBodyNotFiltered(props: ITableBodyNotFilteredAndFiltredProps) {
  //destructuring
  const { trocsPropositionsList, setTrigUseEffect, setServiceNeedName, setisIndicateServiceNeedName } = props;

  const [expandedRowIndex, setExpandedRowIndex] = useState<number | null>(null);

  //gérer la ligne étendu
  function handleExpandedRow(index: number) {
    // Si la ligne est déjà étendue, la rétracter
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null); // Rétracte la ligne
    } else {
      setExpandedRowIndex(index); // Étend la nouvelle ligne
    }
  }

  const [selectedRow, setSelectedRow] = useState<number>();

  const [iconStates, setIconStates] = useState<boolean[]>(new Array(trocsPropositionsList.length).fill(true));

  //gestion icon + to - and - to +
  function handleSwitchIcon(rowNumber: number) {
    setSelectedRow(rowNumber);

    // Inverse l'état de l'icône pour la ligne cliquée
    setIconStates(prev => {
      const newState = [...prev];

      //asign false to icon selected to display a minus
      newState[rowNumber] = false;

      //compare iconStates initiale vs newsState
      if (prev[rowNumber] === newState[rowNumber]) {//si cliqué au meme endroit

        //asign true to icon selected to display a Plus
        newState[rowNumber] = true;

        return newState;

      }
      else {//si pas cliqué au meme endroit

        //reset IconStates to true
        const newsState2 = newState.map(() => true);

        newsState2[rowNumber] = false;

        return newsState2;

      }
    });
  }

  const handleClickToIndicateServNeedName = (serviceOrNeeedName: string | null) => {
    setServiceNeedName(serviceOrNeeedName);
    setisIndicateServiceNeedName(true);
  };

  return (
    <tbody id="tbody-troc-request" className="text-black sm:text-sm lg:text-base">
      {trocsPropositionsList
        .map((proposal, index) => (
          <React.Fragment key={index}>

            {/* part body  */}
            <tr className={`${selectedRow === index && expandedRowIndex === index ? "bg-gray-200" : null} hover:bg-gradient-to-b hover:from-gray-200 hover:to-gray-100 border-b dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-600 cursor-pointer`} onClick={() => { handleExpandedRow(index), handleSwitchIcon(index) }}>
              <td scope="row" className="font-semibold text-gray-900 whitespace-nowrap dark:text-white text-center">
                {capitalizeFirstCharForRequestState(proposal.proposition_state)}
              </td>
              <td className="text-center">
                <TravPublicModal pseudo={proposal.trav_pseudo} />
              </td>
              <td className="td-date-pg-req-troc text-center">
                {formatedDate(proposal.start_date.toString())} au {formatedDate(proposal.end_date.toString())}
              </td>
              <td className="text-center">
                {proposal.res_region}
              </td>
              <td id={`td-icon-plus${index}`} className="td-icon-plus text-center">
                <FontAwesomeIcon className="py-1 text-greenCustom h-8" icon={iconStates[index] ? faCirclePlus : faCircleMinus} />
              </td>
            </tr>

            {/* part expanded row */}
            {expandedRowIndex === index && (
              <>
                <tr id={`tr-expanded-row${index}`} className="tr-expanded-row bg-white">
                  <td colSpan={5}>

                    <div id="div-expanded-row" className="flex flex-col justify-around items-center gap-2">

                      {/* part title */}
                      {proposal.title.charAt(0).toUpperCase() + proposal.title.slice(1).toLocaleLowerCase()}

                      {/* part date */}
                      <div id="date-expand-row" className="w-full flex justify-center">
                        <p className="date-expand-row font-medium">Du {formatedDate(proposal.start_date.toString())} au {formatedDate(proposal.end_date.toString())}</p>
                      </div>

                      {/* separator row */}
                      <span className="border-t border-gray-300 block w-full" />

                      {/* services and needs */}
                      <div className="div-ser-needs flex flex-col justify-around gap-3 w-full">

                        {/* services */}
                        <div id="services" className="flex-1 flex flex-col justify-center gap-2">

                          <label className="block text-center font-medium text-sm sm:text-base lg:text-lg">Ses Services</label>

                          <div id="services-list" className="flex flex-wrap justify-center gap-6">
                            {proposal.services
                              .filter((service) => service != null)
                              .map((service, index) => (
                                <img
                                  key={index}
                                  className="h-20 w-20 cursor-pointer"
                                  src={`${"/servicesDuNomade-besoinsDuRésident/" + service + ".png"}`}
                                  alt={`image ${service}`}
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ))
                            }
                          </div>

                        </div>

                        {/* needs */}
                        <div id="needs" className="flex-1 flex flex-col justify-center gap-2">

                          <label className="block text-center font-medium text-sm sm:text-base lg:text-lg">Ses Besoins</label>

                          <div id="needs-list" className="flex flex-wrap justify-center gap-6">
                            {proposal.needs
                              .filter((service) => service != null)
                              .map((service, index) => (
                                <img
                                  key={index}
                                  className="h-20 w-20 cursor-pointer"
                                  src={`${"/besoinsDuNomade-servicesDuRésident/" + service + ".png"}`}
                                  alt={`image ${service}`}
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ))
                            }
                          </div>

                        </div>

                      </div>

                    </div>

                  </td>
                </tr>

                {/* description and actions */}
                <tr id="tr-expanded-row-descrip" className="mt-1 border-none">
                  <td colSpan={5} className="p-0">

                    {/*separator row  */}
                    <span className="border-t border-gray-300 block mt-1" />

                    {/* Decription du troc */}
                    <div className="my-2 flex flex-col items-center justify-around gap-1">
                      <h2 className="font-medium text-sm sm:text-base lg:text-lg">Description</h2>

                      <div className="border-4 rounded-md overflow-y-auto max-h-16 max-w-[900px] px-2">
                        <p className="break-words text-sm">{proposal.description}</p>
                      </div>
                    </div>

                    {/* actions different */}
                    <div className="actions flex justify-between items-center gap-2 text-sm sm:text-base lg:text-lg">
                      {proposal.proposition_state === "EN_ATTENTE" ?
                        <div className="w-full flex justify-between">
                          <DeclineProposal travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                          <AcceptProposal travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                        </div> :
                        null
                      }
                      {proposal.proposition_state === "REFUSEE" ?
                        <BtnIconeProposalTrash resTrocId={proposal.against_r_troc_pair_id} travTrocId={proposal.trav_Troc_Id} setTrigUseEffect={setTrigUseEffect} /> :
                        null
                      }
                      {proposal.proposition_state === "EFFECTUEE" && proposal.is_commented === false ?
                        <ShareExpRes travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                        :
                        proposal.proposition_state === "EFFECTUEE" && proposal.is_commented === true ?
                          <BtnIconeProposalTrash travTrocId={proposal.trav_Troc_Id} resTrocId={proposal.against_r_troc_pair_id} setTrigUseEffect={setTrigUseEffect} />
                          :
                          null
                      }
                      {proposal.proposition_state === "ACCEPTEE" ?
                        <div className="w-full flex justify-between">
                          <TrocDoneRes resTrocId={proposal.against_r_troc_pair_id} travTrocId={proposal.trav_Troc_Id} setTrigUseEffect={setTrigUseEffect} />
                          <DiscussModal res_troc_id={proposal.against_r_troc_pair_id} trav_troc_id={proposal.trav_Troc_Id} />
                        </div> :
                        null
                      }
                    </div>

                    {/*separator row  */}
                    <span className="border-t border-gray-300 block mt-3" />

                  </td>
                </tr>
              </>
            )}
          </React.Fragment>
        ))
      }
    </tbody>
  )
}